import React from "react";
import { useState, useEffect, useContext } from "react";
import cx from "classnames";
import { client } from "../services/axiosClient";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../reducers/authReducer";
import AuthContext from "../contexts/AuthProvider";
import { ThreeDots } from "react-loader-spinner";
import { useTokenSync } from "../hooks/useTokenSync";
import { defaultLandingPath } from "../utils/routeAccess";

import { makeStyles } from "@material-ui/core/styles";

import styles from "../assets/jss/material-dashboard-pro-react/layouts/welcomeStyle";
import { grayColor } from "../assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles(styles);

export default function Welcome() {
  const classes = useStyles();
  const navigate = useNavigate();

  const [init, setInit] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [splashColor, setSplashColor] = useState("#fff");
  const [clientLogo, setClientLogo] = useState(null);
  const [clientLogoFade, setClientLogoFade] = useState(false);

  const dispatch = useDispatch();
  const { authTokens, isCurrentTokenExpired } = useTokenSync();
  let { logoutUser } = useContext(AuthContext);

  const hasCalledApi = React.useRef(false);
  const logoutUserRef = React.useRef(logoutUser);
  const navigateRef = React.useRef(navigate);
  const dispatchRef = React.useRef(dispatch);

  React.useEffect(() => {
    logoutUserRef.current = logoutUser;
    navigateRef.current = navigate;
    dispatchRef.current = dispatch;
  });

  useEffect(() => {
    if (hasCalledApi.current) return;

    const accessToken = authTokens?.access;

    if (!accessToken || isCurrentTokenExpired()) {
      navigate("/auth/login", { replace: true });
      return;
    }

    hasCalledApi.current = true;

    setTimeout(() => {
      setInit(false);
    }, 0);

    setTimeout(() => {
      client
        .post(
          "api/post_login_info/",
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        )
        .then((response) => {
          dispatchRef.current(setUserDetails(response.data));
          setSplashColor("#fff");
          setClientLogo(response.data.implementation_logo);
          setTimeout(() => {
            setIsLoaded(true);
            setTimeout(() => {
              setSplashColor("#eee");
              setClientLogoFade(true);

              // Aterrissagem hibrida: por atomos no sistema novo, por role
              // no legado (CIF/CIP -> inputs, NON -> no-permission).
              const destination = defaultLandingPath(response.data);

              setTimeout(() => navigateRef.current(destination), 250);
            }, 1500);
          }, 500);
        })
        .catch((error) => {
          console.error("Error fetching post_login_info:", error);
          logoutUserRef.current(
            null,
            "Error fetching project data. Please try again.",
          );
        });
    }, 0);
  }, [authTokens, isCurrentTokenExpired, navigate]);

  return (
    <>
      <div className={classes.wrapper}>
        <div
          className={cx({
            [classes.welcomeText]: true,
            ["init"]: init,
            ["loaded"]: isLoaded,
          })}
        >
          {"welcome"}
        </div>
        <ThreeDots
          color={grayColor[0]}
          ariaLabel="loading"
          height={"12px"}
          wrapperStyle={{}}
          wrapperClass={cx({
            [classes.welcomeSpinner]: true,
            ["init"]: init,
          })}
        />
      </div>
      <div
        className={cx({
          [classes.clientSplash]: true,
          ["loaded"]: isLoaded,
        })}
        style={{ backgroundColor: splashColor }}
      >
        <img
          src={`data:image/png;base64,${encodeURIComponent(clientLogo)}`}
          alt="logo"
          className={cx({
            [classes.clientLogo]: true,
            ["faded"]: clientLogoFade,
          })}
        />
      </div>
    </>
  );
}
